import {
  createPaginatedResponseSchema,
  PaginationMetadataSchema,
} from 'api/common-schemas';
import { z } from 'zod';
export const USERS_LIMIT = 500;

export const UserSchema = z.object({
  id: z.string(),
  name: z.string(),
  roles: z.array(
    z.object({
      color: z.string().nullable(),
      description: z.string().nullable(),
      group_id: z.string().nullable(),
      id: z.string(),
      name: z.string(),
    }),
  ),
  status: z.string(),
  email: z.string(),
  phone_number: z.string().nullable(),
  created_at: z.string(),
  invited_at: z.string().nullable(),
});

export const UsersMetaDataSchema = PaginationMetadataSchema.extend({
  roles: z.array(z.string()).optional(),
});

export type User = z.infer<typeof UserSchema>;
export type UserMetaDataResponse = z.infer<typeof UsersMetaDataSchema>;

export const UsersResponseSchema = createPaginatedResponseSchema(
  UserSchema,
  UsersMetaDataSchema,
);
export type UsersResponse = z.infer<typeof UsersResponseSchema>;

export const GetUsersParamsSchema = z
  .object({
    search: z.string(),
    page: z.number(),
    page_size: z.number(),
    status: z.string(),
    role: z.string(),
    date_added: z.string().datetime(),
  })
  .partial();

export type GetUsersParams = z.infer<typeof GetUsersParamsSchema>;

export enum TokenUserRoles {
  // systemRoles
  COMPANY_ADMIN = 'company-admin',
  USER = 'user',
  VIEWER = 'viewer',
  WELCOME_USER = 'welcome-user',
  // systemRoles end
  SUPER_ADMIN = 'super-admin',
  PROSPECT = 'prospect',
}

export enum TokenUserPermissions {
  TECH_EXPRESS_READ = 'read:techexpress',
  TECH_EXPRESS_WRITE = 'write:techexpress',
  TECH_EXPRESS_MANAGE = 'manage:techexpress',
  //
  NOC_EXPRESS_READ = 'read:nocexpress',
  NOC_EXPRESS_WRITE = 'write:nocexpress',
  //
  ACCESS_EXPRESS_READ = 'read:accessexpress',
  ACCESS_EXPRESS_WRITE = 'write:accessexpress',
  ACCESS_EXPRESS_MANAGE = 'manage:accessexpress',
  //
  USER_MANAGEMENT = 'manage:users',
  ROLE_MANAGE = 'manage:roles',
  USER_ROLE_MANAGEMENT = 'manage:user-roles',
  //
  MELISSA_DATA_VERIFY = 'verify:melissadata',
  //
  CONTACT_GROUPS_READ = 'read:contact-groups',
  CONTACT_GROUPS_WRITE = 'write:contact-groups',
  //
  API_KEYS_MANAGE = 'manage:api-keys',
  //
  MOBILITY_READ = 'read:mobility',
  //
  RESOURCES_READ = 'read:resources',
  RESOURCES_WRITE = 'write:resources',
  // only for testing cases
  TEST = 'read:test',
  INVENTORY_READ = 'read:inventory',
  MANAGE_GROUPS = 'manage:groups',
  GRANITE_INTERNAL = 'manage:granite-internal',
  //
  BRONZE_CUSTOMER_MANAGE = 'manage:bronze',
  //
  WHITELABEL_READ = 'read:whitelabel',
  WHITELABEL_WRITE = 'write:whitelabel',
  WHITELABEL_MANAGE = 'manage:whitelabel',
}
